module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/03-03.651e4361.mp3";